import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import {
  getAIAssistantPage,
  getAIAssistantShare,
} from "@/_pages/ai-assistant/api";
import type {
  AIAssistantPageType,
  AIAssistantShareType,
} from "@/_pages/ai-assistant/model";
import { AIAssistant } from "@/_pages/ai-assistant/ui";

type PageProps = {
  cms: AIAssistantPageType & {
    sharedData: AIAssistantShareType | null;
  };
};

const Page = (props: PageProps) => {
  const { cms } = props;

  return <AIAssistant data={cms} />;
};

export async function getServerSideProps(ctx: any) {
  const { res } = ctx as GetServerSidePropsContext;
  const shareId = ctx.query.share;

  let sharedData = null;

  if (shareId) {
    try {
      sharedData = await getAIAssistantShare(shareId);
    } catch (e) {
      console.error("Share load error", e);
    }
  }

  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getAIAssistantPage()),
        sharedData,
      };
    },
    { res },
  );
}
export default Page;
